<template>
  <div class="shipping-address-form">
    <form-builder
      ref="formBuilder"
      dense
      :model="physicalRecipient"
      :schema="schema"
      @field-changed="fieldChanged"
    >
      <template #streetLine1="{ rules }">
        <address-autocomplete
          id="address-autocomplete"
          v-model="physicalRecipient.streetLine1"
          :rules="rules"
          use-vuetify
          outlined
          name="checkout-physical-streetLine1"
          :label="$t('shippingAddress.streetLine1.label')"
          :aria-label="$t('shippingAddress.streetLine1.label')"
          placeholder=""
          aria-invalid="false"
          @change="updatePhysicalRecipient"
        />
      </template>
      <template #stateOrProvince="{ value }">
        <v-select
          id="checkout-physical-state-or-province"
          :value="value"
          :label="$t('shippingAddress.stateOrProvince.label')"
          :items="statesOrProvinces"
          :rules="statesOrProvinceRules"
          item-text="name"
          item-value="abbreviation"
          class="checkout-physical-state-or-province"
          outlined
          @input="fieldChanged('stateOrProvince', $event)"
        />
      </template>
    </form-builder>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { GET_PHYSICAL_RECIPIENT } from '../../store/get-types'
import { UPDATE_PHYSICAL_RECIPIENT_DATA } from '../../store/action-types'
import GeographyService from '../shared/geography-service'
import { AddressAutocomplete, FormBuilder } from '@tangocard/mango'
import PhysicalDeliveryFormSchema from '@/components/shared/forms/PhysicalDeliveryFormSchema'
import FormValidationRules from '@/components/shared/forms/FormValidationRules'

export default {
  name: 'PhysicalDeliveryForm',
  components: {
    AddressAutocomplete,
    FormBuilder
  },
  inject: ['$validator'],
  props: {
    formIsValid: {
      type: Boolean,
      required: false,
      default: true
    },
    validate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      schema: PhysicalDeliveryFormSchema
    }
  },
  computed: {
    ...mapGetters({
      physicalRecipient: GET_PHYSICAL_RECIPIENT
    }),
    statesOrProvinces () {
      const { countryCode } = this.physicalRecipient
      return GeographyService.getStateList(countryCode)
    },
    statesOrProvinceRules () {
      return [FormValidationRules.required()]
    }
  },
  watch: {
    validate (val) {
      if (val) {
        this.validateForm()
      }
    }
  },
  async mounted () {
    this.updatePhysicalRecipient({ countryCode: 'US' })
  },
  methods: {
    ...mapActions({
      updatePhysicalRecipient: UPDATE_PHYSICAL_RECIPIENT_DATA
    }),
    validateForm () {
      this.$emit('update:formIsValid', this.$refs.formBuilder.validate())
      this.$emit('update:validate', false)
    },
    fieldChanged (field, value) {
      this.updatePhysicalRecipient({ [field]: value })
      this.validateForm()
    }
  }
}
</script>

<style scoped lang="scss">
// Fix for select not matching text field height, look at removing this when bootstrap is removed (RL-1300)
::v-deep {
  .v-select,
  .v-select * {
    line-height: 14px;
  }
  .v-select .v-label {
    line-height: 20px;
  }
}
</style>
